// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3XMR6","header":"PatientBlock_header__d0n8I","label":"PatientBlock_label__9nd_9","option":"PatientBlock_option__2llVv"};